export const APP_KEY: string = 'FLASHMEETING';
export const VERSION: string = '1.10.2';